import DownloadButton from './DownloadButton';
import { makeUTCDateStr } from '../../utilities/dates';
import { renderArrayStr } from '../../utilities/shared';

import styles from '../styles/SummaryCard.module.css';
export default function ContactsCard({ contactData }) {
  const contact_headers = [
    { label: 'Name', key: 'name' },
    { label: 'Title', key: 'title' },
    { label: 'Email', key: 'email' },
    { label: 'Phone', key: 'phone' },
    { label: 'Counties', key: 'counties' },
    { label: 'Affiliation', key: 'affiliation' },
    { label: 'HUCs', key: 'hucs' },
    { label: 'Study Areas', key: 'study_areas' },
    { label: 'Mitigation Areas', key: 'mitigation_areas' },
    { label: 'Outreach Types', key: 'outreach_types' }
  ];
  const fileName = 'Contact';
  return (
    <div
      // className='col-xl-1-12'
      className={styles.container}
      style={{ margin: '10px', background: '#1A4565', border: 'double' }}
    >
      <div className='card' style={{ border: 'none', width: '100%' }}>
        <div
          className={styles.tableContainer}
          style={{ width: '100%', background: 'lightBlue' }}
        >
          <h3 className='card-title' style={{ marginLeft: '10px' }}>
            Contact Information by Affiliation
          </h3>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
                <th>Affiliation</th>
                <th>Counties</th>
                <th>HUCs</th>
                <th>Study Areas</th>
                <th>Mitigation Areas</th>
                <th>Outreach Types</th>
                <th>Email Address</th>
                <th>Phone Number</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              {contactData.map((contact, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: 'center' }}>{contact.name}</td>
                  <td style={{ textAlign: 'center' }}>{contact.title}</td>
                  <td style={{ textAlign: 'center' }}>{contact.affiliation}</td>
                  <td style={{ textAlign: 'center' }}>
                    {renderArrayStr(contact.counties)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {renderArrayStr(contact.hucs)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {renderArrayStr(contact.study_areas)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {renderArrayStr(contact.mitigation_areas)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {renderArrayStr(contact.outreach_types)}
                  </td>
                  <td style={{ textAlign: 'center' }}>{contact.email}</td>
                  <td style={{ textAlign: 'center' }}>{contact.phone}</td>
                  <td style={{ textAlign: 'center' }}>
                    {makeUTCDateStr(contact.startdate)}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {makeUTCDateStr(contact.enddate)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr style={{ color: 'grey' }} />
        </div>
      </div>
      <DownloadButton
        new_data={contactData}
        headers={contact_headers}
        file={fileName}
      />
    </div>
  );
}
